import { CSSProperties, FC, useCallback } from 'react';
import styled from 'styled-components';

import { VerificationRole } from '@typings/user';
import { PremierText } from '@components/text';
import verifiedProIcon from '@assets/icons/verified-pro.png';
import verifiedUserIcon from '@assets/icons/verified-user.png';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const VerifiedIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 4px;
`;

const Name = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.sm};
  color: ${({ theme }) => theme.colors.white};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type Props = {
  name: string;
  verifiedAs?: string;
  nameStyle?: CSSProperties;
};

const UserNameBlock: FC<Props> = ({ name, verifiedAs, nameStyle }) => {
  const renderIcon = useCallback(() => {
    switch (verifiedAs) {
      case VerificationRole.Pro:
        return <VerifiedIcon src={verifiedProIcon} />;
      case VerificationRole.User:
        return <VerifiedIcon src={verifiedUserIcon} />;
      default:
        return null;
    }
  }, [verifiedAs]);

  return (
    <Container>
      {renderIcon()}

      <Name style={nameStyle}>{name}</Name>
    </Container>
  );
};

export default UserNameBlock;
